export default __webpack_public_path__ + "ui/assets/img/attention-invert-black-16.svg";